import React from 'react';
import { Animated, Easing } from 'react-native';
import { Icon } from 'react-native-elements';
 
export default class Spinner extends React.Component {
    constructor() {
        super()
        this.spinValue = new Animated.Value(0)
    }

    spin = () => {
        this.spinValue.setValue(0)

        this.spinning = Animated.timing(
            this.spinValue,
            {
                toValue: 1,
                duration: 3000,
                easing: Easing.linear
            }
        )
        
        this.spinning.start(({ finished }) => { 
            this.spin() 
        });
    }

    componentDidMount() {
        this.spin()
    }
  
    render() {
        const spin = this.spinValue.interpolate({
            inputRange: [0, 1],
            outputRange: ['0deg', '360deg']
        })

        return <Animated.View style={{
                transform: [{rotate: spin}],
            }} >
                <Icon name='spinner' type='font-awesome' color={this.props.color || '#ffffff'} />
        </Animated.View> 
    }
}

 
  


 